import React from "react";
import { useTranslation } from 'react-i18next';
import "./SchemesProjects.css";
import ImportantProjects from "../components/schemes-projects/ImportantProjects";
import Gallery from "../components/schemes-projects/Gallery";
import Schemes from "../components/schemes-projects/Schemes";
import PageHeader from '../components/PageHeader';
import articleIcon from "../assets/icons/article.svg";
import articlePerson from "../assets/icons/article_person.svg";
import DownloadCard from "../components/DownloadCard";  
import DocumentCard from "../components/DocumentCard";
import { Link } from "react-router-dom";
import VillageIllustration from "../components/VillageIllustration";

const SchemesProjects = () => {
  const { t, i18n } = useTranslation();
  
  // English document data
  const documentDataEn = [
    {
      title: "Emailing Ramai Awas Yojana Reforms",
      description:
        "This document provides information about the reforms made to the Ramai Awas Yojana scheme.",
      link: "/assets/GR/Emailing-Ramai-Awas-Yojana-Reforms.pdf",
    },
    {
      title: "Department of Industry, Energy and Labor.",
      description:
        "This document provides information about the Department of Industry, Energy and Labor.",
      link: "/assets/GR/Department-of-Industry-Energy-and-Labor.pdf",
    },
    {
      title: "Backward Classes Welfare Department",
      description:
        "This document provides information about the Backward Classes Welfare Department.",
      link: "/assets/GR/Backward-Classes-Welfare-Department.pdf",
    },
    {
      title: "Pradhan Mantri Awas Yojana Gramin",
      description:
        "This document provides information about the Pradhan Mantri Awas Yojana Gramin scheme.",
      link: "/assets/GR/Pradhan-Mantri-Awas-Yojana-Gramin.pdf",
    },
    {
      title: "Tanda Settlement Improvement Scheme",
      description:
        "This document provides information about the Tanda Settlement Improvement Scheme.",
      link: "/assets/GR/Tanda-Settlement-Improvement-Scheme.pdf",
    },
    {
      title: "Increase in Dalit Settlement Grant",
      description:
        "This document provides information about the Increase in Dalit Settlement Grant.",
      link: "/assets/GR/Increase-in-Dalit-Settlement-Grant.pdf",
    },
    {
      title: "Government decision on orchard cultivation",
      description:
        "This document provides information about the Government decision on orchard cultivation.",
      link: "/assets/GR/Government-decision-on-orchard-cultivation.pdf",
    },
    {
      title: "Maharashtra Gram Panchayat Act 1959",
      description:
        "This document provides information about the Maharashtra Gram Panchayat Act 1959.",
      link: "/assets/GR/Maharashtra-Gram-Panchayat-Act-1959.pdf",
    },
    {
      title: "Ramai Revised Grant Sha Ni 7 January 2017",
      description:
        "This document provides information about the Ramai Revised Grant Sha Ni 7 January 2017.",
      link: "/assets/GR/Ramai-Revised-Grant-Sha-Ni-7-January-2017.pdf",
    },
    {
      title: "Public Service Rights Act 13-2-2019",
      description:
        "This document provides information about the Public Service Rights Act 13-2-2019.",
      link: "/assets/GR/Public-Service-Rights-Act-13-2-2019.pdf",
    }
  ];

  // Marathi document data
  const documentDataMr = [
    {
      title: "रमाई आवास योजना सुधारणा ईमेलिंग",
      description:
        "हा दस्तऐवज रमाई आवास योजना योजनेत केलेल्या सुधारणांबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Emailing-Ramai-Awas-Yojana-Reforms.pdf",
    },
    {
      title: "उद्योग, ऊर्जा आणि कामगार विभाग.",
      description:
        "हा दस्तऐवज उद्योग, ऊर्जा आणि कामगार विभागाबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Department-of-Industry-Energy-and-Labor.pdf",
    },
    {
      title: "मागासवर्ग कल्याण विभाग",
      description:
        "हा दस्तऐवज मागासवर्ग कल्याण विभागाबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Backward-Classes-Welfare-Department.pdf",
    },
    {
      title: "प्रधान मंत्री आवास योजना ग्रामीण", 
      description:
        "हा दस्तऐवज प्रधान मंत्री आवास योजना ग्रामीण योजनेबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Pradhan-Mantri-Awas-Yojana-Gramin.pdf",
    },
    {
      title: "टांडा वसाहत सुधारणा योजना",
      description:
        "हा दस्तऐवज टांडा वसाहत सुधारणा योजनेबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Tanda-Settlement-Improvement-Scheme.pdf",
    },
    {
      title: "दलित वसाहत अनुदान वाढ",
      description:
        "हा दस्तऐवज दलित वसाहत अनुदान वाढ योजनेबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Increase-in-Dalit-Settlement-Grant.pdf",
    },
    {
      title: "बागायती लागवडीवरील सरकारी निर्णय",
      description:
        "हा दस्तऐवज बागायती लागवडीवरील सरकारी निर्णयांबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Government-decision-on-orchard-cultivation.pdf",
    },
    {
      title: "महाराष्ट्र ग्राम पंचायत अधिनियम 1959",
      description:
        "हा दस्तऐवज महाराष्ट्र ग्राम पंचायत अधिनियम 1959 याबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Maharashtra-Gram-Panchayat-Act-1959.pdf",
    },
    {
      title: "रमाई सुधारित अनुदान शा नी 7 जानेवारी 2017",
      description:
        "हा दस्तऐवज रमाई सुधारित अनुदान शा नी 7 जानेवारी 2017 याबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Ramai-Revised-Grant-Sha-Ni-7-January-2017.pdf",
    },
    {
      title: "सार्वजनिक सेवा हक्क अधिनियम 13-2-2019",
      description:
        "हा दस्तऐवज सार्वजनिक सेवा हक्क अधिनियम 13-2-2019 याबद्दल माहिती प्रदान करतो.",
      link: "/assets/GR/Public-Service-Rights-Act-13-2-2019.pdf",
    }
  ];

  const currentDocumentData = i18n.language === "en" ? documentDataEn : documentDataMr;
  
  return (
    <>
      <div className="section-scheme section-padding bg-image-section">
        <PageHeader
          breadcrumb={[
            <Link key="home" to="/">{t('home.breadcrumb')}</Link>,
            <span key="schemes-projects">{t('schemesProjects.breadcrumb')}</span>
          ]}
          title={t('schemesProjects.title')}
          description={t('schemesProjects.description')}
        />
        <div className="flex flex-col gap-3">
          <ImportantProjects />
          <Gallery />
          <Schemes />

          <div className="border rounded-md p-4 bg-white flex flex-col gap-2">
     
                <div className="flex flex-col gap-2">
                <div className="flex gap-3 items-center">
                  <img
                  className="w-10 h-10 relative"
                  style={{
                    background:
                    "linear-gradient(135deg, #FF8027 0%, #F54900 100%)",
                    padding: "8px",
                    border: "1px",
                    borderRadius: '4px'
                  }}
                  src={articlePerson}
                  alt="application Icon"
                  />
                  <h2 className="font-semibold w-full h-fit text-2xl max-sm:text-xl m-0">
                  {t("importantGr") || "महत्वाचे जीआर"}
                  </h2>
                </div>
                <p className="text-base font-normal">
                  {t(
                  "महाराष्ट्र शासनाच्या विविध योजनांची माहिती मिळवा, ज्यात कृषी, आरोग्य, शिक्षण आणि ग्रामीण विकास योजनांचा समावेश आहे."
                  ) ||
                  "Get information about various schemes of the Government of Maharashtra, including agriculture, health, education and rural development schemes."}
                </p>
                </div>
 <div className="grid max-sm:grid-cols-1 max-md:grid-cols-2 max-lg:grid-cols-3 grid-cols-4 gap-4 w-full">
            {currentDocumentData.map((doc, index) => (
              <DocumentCard
                key={index}
                title={doc.title}
                description={doc.description}
                downloadLink={doc.link}
                showSampleForm={false}
                showDescription={false}
              />
            ))}
          </div>
               
                
              </div>
          <div className="border rounded-md p-4 bg-white flex flex-col gap-2">
     
                <div className="flex flex-col gap-2">
                <div className="flex gap-3 items-center">
                  <img
                  className="w-10 h-10 relative"
                  style={{
                    background:
                    "linear-gradient(135deg, #00B8DB 0%, #004A5D 100%)",
                    padding: "8px",
                    border: "1px",
                    borderRadius: '4px'
                  }}
                  src={articleIcon}
                  alt="application Icon"
                  />
                  <h2 className="font-semibold w-full h-fit text-2xl max-sm:text-xl m-0">
                  {t("AppInstall") || "महाराष्ट्र शासनाच्या सर्व योजना"}
                  </h2>
                </div>
                <p className="text-base font-normal">
                  {t(
                  "महाराष्ट्र शासनाच्या विविध योजनांची माहिती मिळवा, ज्यात कृषी, आरोग्य, शिक्षण आणि ग्रामीण विकास योजनांचा समावेश आहे."
                  ) ||
                  "Get information about various schemes of the Government of Maharashtra, including agriculture, health, education and rural development schemes."}
                </p>
                </div>

                <DownloadCard
                  title="महाराष्ट्र शासनाच्या सर्व योजना"
                  titleEn="All Schemes of Government of Maharashtra"
                  description="महाराष्ट्र शासनाच्या विविध योजनांची माहिती मिळवा, ज्यात कृषी, आरोग्य, शिक्षण आणि ग्रामीण विकास योजनांचा समावेश आहे."
                  descriptionEn="Get information about various schemes of the Government of Maharashtra, including agriculture, health, education and rural development schemes."
                  downloadLink="/assets/forms/महाराष्ट्र शासनाच्या सर्व योजना -1.pdf"
                  buttonLabel="डाउनलोड"
                  buttonLabelEn="Download"
                  showMobileApp={true}
                  mobileAppLink="https://api.appexecutable.com/mobile/download-app/appId/959e87296efa"
                  mobileAppLabel="मोबाइल अॅप"
                  mobileAppLabelEn="Mobile App"
                  />
                
              </div>
        </div>
      </div>
      <VillageIllustration />
    </>
  );
};

export default SchemesProjects;
